import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';


import ReactTable from "react-table";
import "react-table/react-table.css";

import Spinner from 'react-spinkit';

import moment from 'moment';

import * as actions from '../../actions/proveedores';

import IconSave from 'react-icons/lib/md/save';


import {api, request, API_URL} from '../../actions/_request';



const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);

class KardexProveedor extends React.Component{
	constructor(props) {

        super(props);

        this.state = {
           	fecha_inicio : '2000-01-01',
           	fecha_fin 	 : moment().add(1, 'days').format('Y-MM-DD'),
            filtro : 3,
        };
        
        this.buscar = this.buscar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this); 
    }

    handleInputChange(event) {
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
     
        this.setState({
            [name] : value
        });
    }

    handleSelectChange(select, name) {

        const value = select === null ? null : select.target.value;
        const nameSelect = select.target.name;

        this.setState({[nameSelect] : value});

    }

    buscar(evt){
    	evt.preventDefault();

    	let {fecha_inicio , fecha_fin , filtro} = this.state;
    	let { proveedor , consulta} = this.props;

      if(consulta == 1)
    	 window.open(`${API_URL}/consultaKardexCliente/${proveedor}/${fecha_inicio}/${fecha_fin}`);
      else if(consulta == 2)
        window.open(`${API_URL}/consultaFacturaAbonoscliente?proveedor=${proveedor}&fecha1=${fecha_inicio}&fecha2=${fecha_fin}&filtro=${filtro}`);
      else if(consulta == 3)
        window.open(`${API_URL}/cliente/productosComprados/${proveedor}/${fecha_inicio}/${fecha_fin}`);
    }

    render(){
    	let {fecha_inicio , fecha_fin ,filtro} = this.state;
    	return(
    		<Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal_cliente">
                <form >
                <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                	<div className="row">
                		<div className="col-4">
                			<div className="form-group">
                   				<label>inicio:</label>
                   				<Input
                   					placeholder=""
                   					type="date"
                   					name="fecha_inicio"
                   					value={fecha_inicio}
                   					onChange={this.handleInputChange}
                   				/>
                   			</div>
                		</div>
                		<div className="col-4">
                			<div className="form-group">
                   				<label>Fin:</label>
                   				<Input
                   					placeholder=""
                   					type="date"
                   					name="fecha_fin"
                   					value={fecha_fin}
                   					onChange={this.handleInputChange}
                   				/>
                   			</div>
                		</div>
                    <div className="col-4">
                      <label>Cliente:</label><br/>
                      <span className="mt-1">{this.props.nombreProveedor}</span>
                    </div>
                	</div>
                  {this.props.consulta == 2?
                    <div className="row">
                      <div className="col-4">
                        <div className="form-group">
                          <label>Filtro:</label><br/>
                          <Input type="select" 
                            name="filtro" 
                            id="exampleSelect" 
                            value={filtro} 
                            onChange={(e) => this.handleSelectChange(e,'moneda')}
                            style={{width: '130px'}}
                          >
                            <option value={'3'}>Todo</option>
                            <option value={'1'}>Saldo 0</option>
                            <option value={'2'}>Con Saldo</option>
                          </Input>
                          {/*</select>*/}
                        </div>
                      </div>
                    </div> : ''
                  }
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.proveedores.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit"  onClick={this.buscar} >
                                <IconSave />&nbsp;Buscar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                </form>
            </Modal>
    	);
    }
}

function mapStateToProps(state, ownProps) {
    return {
        proveedores : state.proveedores,
        auth:state.auth
    }
};

export default connect(mapStateToProps, actions)(KardexProveedor)


// WEBPACK FOOTER //
// ./src/views/clientes/ModalKardexCliente.js